/**
 * Permission codes the cycle, version-register, compare and availability screens
 * use in addition to `../permissions.ts` (owned elsewhere this wave).
 *
 * They are the dot-strings `internal/budget/permissions.go` registers:
 *  - `cycleManage` assigns, reassigns, removes and reopens cost-centre owners;
 *  - `cycleOpen` opens and closes a cycle (the act that notifies owners);
 *  - `check` reads the availability figure (`GET /budget-availability`).
 *
 * The split between `cycleManage` and `cycleOpen` lets a planner prepare a cycle
 * without being able to launch it, so the screen asks for each separately.
 */
export const BUDGET_CYCLE_PERMISSIONS = {
  cycleManage: 'budget.cycle.manage',
  cycleOpen: 'budget.cycle.open',
  check: 'budget.check',
} as const
